module.exports = __webpack_public_path__ + "static/media/logo.ccc9c47e.png";